import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-date",
  "use": "icon-date-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-date\"><path d=\"M810.656 128V42.656h-85.344V128H298.656V42.656H213.312V128H42.656v853.344h938.656V128h-170.656zM896 896H128V384h768v512z\" p-id=\"29331\" /><path d=\"M213.344 469.344h128v128h-128v-128zM448 469.344h128v128h-128v-128zM682.656 469.344h128v128h-128v-128zM213.344 682.656h128v128h-128v-128zM448 682.656h128v128h-128v-128zM682.656 682.656h128v128h-128v-128z\" p-id=\"29332\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/date.svg
// module id = Ve8B
// module chunks = 12